// The 6 shoppable creative formats. Metadata only (id, name, blurb, glyph);
// each engine component lives in its own file and is dynamically imported by
// the gallery so we only ship the active engine's JS.
//
// Kept framework-agnostic (no React import) so it can be read on the server
// for the page's ItemList JSON-LD and the gallery's chip row alike.

export type FormatId =
  | 'shop-the-look'
  | 'shoppable-story'
  | 'social-gallery'
  | 'interactive-pdp'
  | 'lookbook'
  | 'before-after'

export interface FormatMeta {
  id: FormatId
  name: string
  /** One-line description of the interaction. */
  blurb: string
  /** Where this format earns its place. */
  surface: string
}

export const FORMATS: FormatMeta[] = [
  {
    id: 'shop-the-look',
    name: 'Shop the Look',
    blurb: 'Tap-to-shop hotspots over a lifestyle image, with a shop-this-look rail.',
    surface: 'Homepage hero · campaign landing pages',
  },
  {
    id: 'shoppable-story',
    name: 'Shoppable Story',
    blurb: 'A vertical reel that auto-advances timed product cards. Tap to skip, hold to pause.',
    surface: 'PDP · stories block · mobile-first feeds',
  },
  {
    id: 'social-gallery',
    name: 'Social Gallery',
    blurb: 'A masonry wall of real customer posts that opens a shoppable card on tap.',
    surface: 'Homepage social proof · category pages',
  },
  {
    id: 'interactive-pdp',
    name: 'Interactive PDP Hero',
    blurb: 'A product hero with feature hotspots, a rating snapshot, and a verified Q&A.',
    surface: 'Product detail page',
  },
  {
    id: 'lookbook',
    name: 'Lookbook Carousel',
    blurb: 'Auto-advancing looks, each with an add-to-cart product rail.',
    surface: 'Collection pages · seasonal drops',
  },
  {
    id: 'before-after',
    name: 'Before / After',
    blurb: 'A draggable reveal slider for transformations and try-on results.',
    surface: 'Beauty · home · results-led PDPs',
  },
]

export function formatById(id: FormatId): FormatMeta {
  return FORMATS.find((f) => f.id === id) ?? FORMATS[0]
}
